import React from "react";
import { Link } from "react-router-dom";
import Animate from "../../components/Animate/Animate";
import "./portfolio.css";
import { IoIosArrowDown } from "react-icons/io";
import { IconContext } from "react-icons";
import "../../App.css";
import civ from "../../assets/civ.png";
import work from "../../assets/123workforce.png";
import gospel from "../../assets/gospel.png";
import bijoy from "../../assets/bijoy.png";
import injeel from "../../assets/injeel.png";
import song from "../../assets/song.png";

function Porfolio() {
  return (
    <div className='port-container'>
      <h1 className='port-text'>Works</h1>
      <Animate className='card-container'>
        <div className='card'>
          <img
            src={civ}
            alt='civ'
            className='img-port'
            onClick={() => window.open("https://civ.ie/")}
          />
        </div>
        <div className='card'>
          <img
            src={work}
            alt='123workforce'
            className='img-port'
            onClick={() => window.open("https://www.123workforce.com/")}
          />
        </div>
        <div className='card'>
          <img
            src={gospel}
            alt='gospel'
            className='img-port'
            onClick={() => window.open("https://sacrificeict.org/")}
          />
        </div>
        <div className='card'>
          <img
            src={bijoy}
            alt='bijoy'
            className='img-port'
            onClick={() => window.open("https://bijoyministriesintl.org/")}
          />
        </div>
        <div className='card'>
          <img
            src={injeel}
            alt='injeel'
            className='img-port'
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.andrewroy3535.frontend&fbclid=IwAR2lvPFVDr2H1eQQr1y8G57G6qSymnP-TgEiIk02E-Fvv8VDFpCDmbFvdog"
              )
            }
          />
        </div>
        <div className='card'>
          <img
            src={song}
            alt='song'
            className='img-port'
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=isae.songs&fbclid=IwAR3hYVYS7EEsUoseNgkPuKPaugcSKpNnwogAKIDdG0Wmn9mIqDYV_oJVoAQ"
              )
            }
          />
        </div>
      </Animate>
      <div
        style={{ position: "absolute", left: "2%", top: "50%" }}
        className='navigator-port '>
        <Link to='/skills' className='moveArrowRight'>
          <IconContext.Provider value={{ color: "#7a7a7a", size: "3rem" }}>
            <div className='hover-text-div'>
              <IoIosArrowDown style={{ transform: "rotate(90deg)" }} />
              <p className='hover-text'>Skills</p>
            </div>
          </IconContext.Provider>
        </Link>
      </div>
      <div
        style={{ position: "absolute", right: "2%", top: "50%" }}
        className='navigator-port '>
        <Link to='/' className='moveArrowLeft'>
          <IconContext.Provider value={{ color: "#7a7a7a", size: "3rem" }}>
            <div className='hover-text-div'>
              <p className='hover-text'>About</p>
              <IoIosArrowDown style={{ transform: "rotate(-90deg)" }} />
            </div>
          </IconContext.Provider>
        </Link>
      </div>
    </div>
  );
}

export default Porfolio;
